import React from "react";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import eachDayOfInterval from "date-fns/eachDayOfInterval";

function DatePickerBasic({
  autoFocus = false, // bool
  closeOnSelect = true, // bool
  defaultValue, //object
  value,
  desktopModeMediaQuery, //string
  disabled = false, //bool
  disableFuture = false, //bool
  disableHighlightToday = false, //bool
  disableOpenPicker = false, //bool
  disablePast = false, //bool
  displayWeekNumber = false, //bool
  fixedWeekNumber, //number
  formatDensity, //'dense' | 'spacious
  inputRef, //ref
  name, //node
  loading, // bool
  localeText, //object
  maxDate, //object
  minDate, //object
  monthsPerRow = 3, //3 | 4 Months rendered per row.
  open, // bool
  openTo = "day", // 'day' | 'month' | 'year'
  orientation, //'landscape' | 'portrait'
  reduceAnimations = true, // bool
  referenceDate, // object
  selectedSections, //'all' | 'day'| 'empty'| 'hours' | 'meridiem'| 'minutes'| 'month' | 'seconds' | 'weekDay' | 'year'| number
  showDaysOutsideCurrentMonth, //bool
  slotProps, //object
  slots, //object
  sx, //object
  timezone, //string
  view,
  views = ["year", "month", "day"],
  format = "YYYY-MM-DD",
  viewRenderers,
  yearsPerRow,
  currentLocale = "en", // string 기본 언어 영어(dayjs/locale 모듈 참조)(https://www.npmjs.com/package/dayjs?activeTab=code)
  dayOfWeekFormatter = (e) => {}, //func
  onAccept = (e) => {}, //func
  onChange = (e) => {}, //func
  onClose = (e) => {}, //func
  onError = (e) => {}, //func
  onMonthChange = (e) => {}, //func
  onOpen = (e) => {}, //func
  onSelectedSectionsChange = (e) => {}, //func
  onViewChange = (e) => {}, //func
  onYearChange = (e) => {}, //func
  renderLoading = (e) => {}, //func
  shouldDisableDate = (e) => {}, //func
  shouldDisableMonth = (e) => {}, //func
  shouldDisableYear = (e) => {}, //func
}) {
  // 마운트 시 언어팩 로드
  React.useEffect(() => {
    loadLocaleData(currentLocale);
  }, []);

  const dayOfWeekFormatterButton = (e) => {
    dayOfWeekFormatter();
  };
  const onAcceptButton = (e) => {
    onAccept(e);
  };
  const onChangeButton = (e) => {
    onChange(e);
  };
  const onCloseButton = (e) => {
    onClose(e);
  };
  const onErrorButton = (e) => {
    onError(e);
  };
  const onMonthChangeButton = (e) => {
    onMonthChange();
  };
  const onOpenButton = (e) => {
    onOpen(e);
  };
  const onSelectedSectionsChangeButton = (e) => {
    onSelectedSectionsChange();
  };
  const onViewChangeButton = (e) => {
    onViewChange();
  };
  const onYearChangeButton = (e) => {
    onYearChange();
  };
  const renderLoadingButton = (e) => {
    renderLoading();
  };
  const shouldDisableDateButton = (e) => {
    shouldDisableDate(e);
  };
  const shouldDisableMonthButton = () => {
    shouldDisableMonth();
  };
  const shouldDisableYearButton = () => {
    shouldDisableYear();
  };

  // 동적으로 언어팩을 로드하는 함수
  const loadLocaleData = async (locale) => {
    try {
      await import(`dayjs/locale/${locale}.js`);
    } catch (error) {
      console.error("언어팩 로드 실패:", error);
    }
  };

  return (
    <LocalizationProvider
      dateAdapter={AdapterDayjs}
      adapterLocale={currentLocale}
      dateFormats={{
        // Day.js 형식 변경
        dayjs: "YYYY-MM-DD",
      }}
    >
      <DatePicker
        autoFocus={autoFocus}
        closeOnSelect={closeOnSelect}
        defaultValue={defaultValue}
        value={value}
        desktopModeMediaQuery={desktopModeMediaQuery}
        disabled={disabled}
        disableFuture={disableFuture}
        disableHighlightToday={disableHighlightToday}
        disableOpenPicker={disableOpenPicker}
        disablePast={disablePast}
        displayWeekNumber={displayWeekNumber}
        fixedWeekNumber={fixedWeekNumber}
        format={format}
        formatDensity={formatDensity}
        inputRef={inputRef}
        label={name}
        loading={loading}
        localeText={localeText}
        maxDate={maxDate}
        minDate={minDate}
        monthsPerRow={monthsPerRow}
        open={open}
        openTo={openTo}
        orientation={orientation}
        reduceAnimations={reduceAnimations}
        referenceDate={referenceDate}
        selectedSections={selectedSections}
        showDaysOutsideCurrentMonth={showDaysOutsideCurrentMonth}
        slotProps={slotProps}
        viewRenderers={viewRenderers}
        views={views}
        yearsPerRow={yearsPerRow}
        slots={slots}
        sx={sx}
        timezone={timezone}
        view={view}
        dayOfWeekFormatter={dayOfWeekFormatterButton}
        onAccept={onAcceptButton}
        onChange={onChangeButton}
        onClose={onCloseButton}
        onError={onErrorButton}
        onMonthChange={onMonthChangeButton}
        onOpen={onOpenButton}
        onSelectedSectionsChange={onSelectedSectionsChangeButton}
        onViewChange={onViewChangeButton}
        onYearChange={onYearChangeButton}
        renderLoading={renderLoadingButton}
        shouldDisableDate={shouldDisableDate}
        shouldDisableMonth={shouldDisableMonthButton}
        shouldDisableYear={shouldDisableYearButton}
      />
    </LocalizationProvider>
  );
}

export default React.memo(DatePickerBasic);
